import Http from '@/utils/request'
import type {
  FollowCartoonListResponse,
  FollowCartoonPageResponse,
  FollowFeedResponse,
} from './type'

export function fetchFollowCartoons(): Promise<FollowCartoonListResponse> {
  return Http({
    url: '/user/follow/cartoon',
    method: 'get',
  })
}

export function fetchFollowFeed(pageNo: number = 1): Promise<FollowFeedResponse> {
  return Http({
    url: '/distribute/follow',
    method: 'get',
    params: {
      pageNo: Math.max(1, pageNo),
    },
  })
}

export function fetchFollowCartoonPage(pageNo: number = 1): Promise<FollowCartoonPageResponse> {
  return Http({
    url: '/cartoon/follow',
    method: 'get',
    params: {
      pageNo: Math.max(1, pageNo),
    },
  })
}

export type {
  FollowCartoonDetailItem,
  FollowCartoonItem,
  FollowCartoonListResponse,
  FollowCartoonPage,
  FollowCartoonPageResponse,
  FollowFeedPage,
  FollowFeedResponse,
} from './type'
